var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ax-progress",style:({ backgroundColor: _vm.backgroundColor, height: _vm.height })},[_c('div',{class:_vm.spinnerClasses,style:(_vm.spinnerStyles)})])
}
var staticRenderFns = []

export { render, staticRenderFns }